const SUBSCRIBED_COOKIE = 'signup_popup_subscribed';
const PENDING_KEY = 'signup_popup_pending';

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, days) {
  document.cookie = `${name}=${value}; max-age=${days * 24 * 60 * 60}; path=/; SameSite=Lax`;
}

class SignupGate extends HTMLElement {
  connectedCallback() {
    this.popupId = this.dataset.popupId;
    this.formPanel = this.querySelector('[data-gate-panel="form"]');
    this.unlockedPanel = this.querySelector('[data-gate-panel="unlocked"]');
    this.rememberDays = Number(this.dataset.rememberDays) || 30;

    if (getCookie(SUBSCRIBED_COOKIE)) {
      this.unlock();
    }
    else {
      this.bindForm();
    }

    this.handleReturnFromSubmit();
  }

  bindForm() {
    const form = this.formPanel?.querySelector('form');
    form?.addEventListener('submit', () => {
      sessionStorage.setItem(PENDING_KEY, this.popupId);
    });
  }

  handleReturnFromSubmit() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') !== 'true') return;

    const pendingId = sessionStorage.getItem(PENDING_KEY);
    if (pendingId !== this.popupId) return;

    sessionStorage.removeItem(PENDING_KEY);
    setCookie(SUBSCRIBED_COOKIE, '1', this.rememberDays);
    this.unlock();

    params.delete('customer_posted');
    const query = params.toString();
    window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);

    this.closest('page-popup')?.open();
  }

  unlock() {
    if (this.formPanel) this.formPanel.hidden = true;
    if (this.unlockedPanel) this.unlockedPanel.hidden = false;
  }
}

customElements.define('signup-gate', SignupGate);
